import { render } from "./icon-add.vue?vue&type=template&id=92f4880e&scoped=true"
import script from "./icon-add.vue?vue&type=script&lang=js"
export * from "./icon-add.vue?vue&type=script&lang=js"

import "./icon-add.vue?vue&type=style&index=0&id=92f4880e&lang=scss&scoped=true"

import exportComponent from "/Users/kariyaryoma/python/sg-post/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f4880e"]])

export default __exports__